import React from 'react';
import { HEALTH_CHECK_BAND } from '../content/home';
import { useHealthCheck } from '../health-check/HealthCheckProvider';
import Button from '../primitives/Button';
import Reveal from '../primitives/Reveal';

/** The Porcelain band that opens the Health Check panel (guidelines p.55). */
export default function HealthCheckBand() {
  const { open } = useHealthCheck();
  return (
    <section className="mk-hc-band" aria-labelledby="hc-band-title">
      <div className="mk-container">
        <Reveal>
          <p className="t-details">{HEALTH_CHECK_BAND.label}</p>
          <h2 id="hc-band-title" className="mk-hc-band__title t-display">
            {HEALTH_CHECK_BAND.title}
          </h2>
          <p className="mk-hc-band__body t-body">{HEALTH_CHECK_BAND.body}</p>
          <Button variant="fill" onClick={open} aria-haspopup="dialog">
            {HEALTH_CHECK_BAND.cta}
          </Button>
        </Reveal>
      </div>
    </section>
  );
}
